import { disableScroll, enableScroll, bindEvents } from '../components/_helpers';

export default class FiltersModal {
    public constructor(
        private readonly filtersWrapper: HTMLElement,
        private readonly openButtonsSelector: string,
        private readonly closeButtonsSelector: string,
    ) {}

    public async init(): Promise<void> {
        bindEvents(this.openButtonsSelector, 'click', this.openModal.bind(this));
        bindEvents(this.closeButtonsSelector, 'click', this.closeModal.bind(this));
    }

    private async openModal(): Promise<void> {
        this.filtersWrapper.classList.remove('-translate-x-full');
        disableScroll();
    }

    private async closeModal(): Promise<void> {
        this.filtersWrapper.classList.add('-translate-x-full');
        enableScroll();
    }

}